import { memo } from 'react';
import { Modal } from '@shopify/polaris';
import { LARK_SCHEDULER_URL } from '@/constants';
import { StyledSchedulerFrame } from './styled';

interface IStrategyCallModalProps {
  open: boolean;
  onClose: () => void;
}

/**
 * TR-480: modal dùng chung mở Lark scheduler để merchant book lịch tư vấn 1:1 ngay trong app.
 * Dùng bởi tile Help center (Dashboard) và banner "Need a custom solution?" (Plan page).
 */
const StrategyCallModal = ({ open, onClose }: IStrategyCallModalProps) => {
  return (
    <Modal open={open} onClose={onClose} title="1:1 Strategy Call" size="large">
      <Modal.Section>
        <StyledSchedulerFrame
          src={LARK_SCHEDULER_URL}
          title="Lark scheduler - 1:1 Strategy Call"
          loading="lazy"
          allow="fullscreen"
        />
      </Modal.Section>
    </Modal>
  );
};

export default memo(StrategyCallModal);
